import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { FormikProvider } from "formik";
import { Col, Form, Row } from "reactstrap";
import { IRootState } from "../../reducers";
import {
  getEntities as getFormData,
  reset as resetPostulate,
} from "../../reducers/postulateReducer";
import {
  createEntity as createCandidate,
  updateEntity as updateCandidate,
  reset as resetCandidate,
} from "../../reducers/candidateReducer";
import { reset as resetCode } from "../../reducers/codeReducer";
import { IStepper } from "../../shared/model/IStepper";
import { FirstStepForm } from "./form/firstStep/FirstStepForm";
import { SecondStepForm } from "./form/secondStep/SecondStepForm";
import { ThirdStepForm } from "./form/thirdStep/ThirdStepForm";
import {
  IAddresFormik,
  initialDataAddress,
  initialValues as initialValuesCandidate,
  newCandidateResponse,
} from "./PostulateModel";
import { useFormikPostulate } from "./useFormikPostulate";
import { RouteComponentProps } from "react-router-dom";
import { ButtonsGroup } from "./form/ButtonsGroup";
import { SpinnerKonecta } from "../../shared/layout/spinner/Spinner";
import { initialStepper } from "./form/stepper/initialStepper";
import { Stepper } from "../../shared/components/stepper/Stepper";
import { IApplicationQuestion } from "../../shared/model/application-question.model";
import { ModalQuestions } from "./form/questions/ModalQuestions";
import {
  initialStateQuestions,
  IQuestion,
} from "../../shared/model/IQuestions";
import { ICandidate } from "../../shared/model/candidate.model";
import ModalDocumentProcess from "./modal-document-process/ModalDocumentProcess";
import { ICandidateToApplication } from "../../shared/model/candidate-to-application.model";
import { IMessage } from "../../shared/model/message.model";
import { ModalResponse } from "../../shared/dialog/modal-response";
import { ModalError } from "../../shared/dialog/modal-error";
import { SpinnerDni } from "../../shared/layout/spinner/SpinnerDni";

interface IPostulateComponent
  extends StateProps,
    DispatchProps,
    RouteComponentProps<{ idapplication: string }> {}

export const Postulate = (props: IPostulateComponent) => {
  const { formData, candidate, validation } = props;
  const myRef = useRef<HTMLInputElement>(null);
  const messageSuccess: IMessage = {
    title: "¡Te postulaste con éxito!",
    body: "Muchas gracias por tu interés.",
    footer: "Nos pondremos en contacto en el caso que continues en el proceso.",
  };
  const messageCompleteFields = {
    response: {
      data: {
        message: "Warning: Debe completar todos los campos",
      },
    },
  };
  const [errorIncompleteFields, setErrorIncompleteFields] =
    useState<boolean>(false);
  const [showErrorsInputs, setShowErrorsInputs] = useState<boolean>(false);

  const [stepper, setStepper] = useState<IStepper>(initialStepper);
  const [showModalQuestions, setShowModalQuestions] = useState<boolean>(false);
  const [questionsState, setQuestionsState] = useState<IApplicationQuestion[]>(
    []
  );
  const [initialValues, setInitialValues] = useState<ICandidate>(
    initialValuesCandidate
  );
  const [currentQuestion, setCurrentQuestion] = useState<IQuestion>(
    initialStateQuestions
  );
  const [showModalConfirm, setShowModalConfirm] = useState(false);

  // State for the "IF Candidate is NEW or NOT" in order to CREATE or UPDATE
  const [isNew, setIsNew] = useState<boolean>(true);
  // State del modal principal
  const [showModal, setShowModal] = useState(false);
  // State del modal de Documento Existente
  const [showDocExists, setShowDocExists] = useState(false);
  // State del bodyModal de Intro de Codigo
  const [showCode, setShowCode] = useState(false);
  // State del bodyModal de carga exitosa
  const [showSaved, setShowSaved] = useState(false);
  // show alredy Applied
  const [showAlreadyApplied, setShowAlreadyApplied] = useState(false);

  const resetReducers = () => {
    // OK
    props.resetCandidate();
    props.resetPostulate();
    props.resetCode();
  };
  const handleClose = () => {
    // OK
    resetReducers();
    props.history.goBack();
  };

  const handleCloseIncompoleteFields = () => {
    setErrorIncompleteFields(false);
  };

  const executeScroll = () => {
    // OK
    myRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const getAdditionalQuestion = (newCurrent: number) => {
    // OK
    if (questionsState && questionsState.length) {
      if (questionsState[newCurrent] && newCurrent < questionsState.length) {
        setCurrentQuestion({
          ...currentQuestion,
          previous: newCurrent === 0 ? 0 : newCurrent - 1,
          current: newCurrent,
          next: newCurrent + 1,

          currentQuestion: questionsState[newCurrent],
        });
      } else {
        sendForm();
      }
      if (newCurrent === 0) {
        setShowModalQuestions(true);
      }
    } else {
      sendForm();
    }
  };

  const saveEntityConfirm = (entity: ICandidate) => {
    // OK
    if (isNew) {
      props.createCandidate(entity, props.match.params.idapplication);
    } else {
      props.updateCandidate(entity, props.match.params.idapplication);
    }
  };

  const { formik } = useFormikPostulate({
    // OK
    initialValues,
    stepper,
    saveEntityConfirm,
    setErrorIncompleteFields,
  });

  const validate = async () => {
    await formik.validateForm();
  };

  const saveConfirm = () => {
    formik.handleSubmit();
  };

  const sendForm = () => {
    setShowModalQuestions(false);
    setShowModalConfirm(true);
  };

  useEffect(() => {
    resetReducers();
    props.getFormData(props.match.params.idapplication);
    executeScroll();
  }, []);

  useEffect(() => {
    if (formData.entities.application?.applicationQuestions) {
      const newQuestion = {
        ...currentQuestion,
        next: 1,
        currentQuestion: formData.entities.application.applicationQuestions[0],
        numberOfQuestions:
          formData.entities.application.applicationQuestions.length,
      };
      setCurrentQuestion(newQuestion);
    }
    const questions = formData.entities.application?.applicationQuestions
      ? formData.entities.application?.applicationQuestions
      : [];
    setQuestionsState(questions);

    const candidateResponseQuestions = questions.map((el) => {
      return {
        ...newCandidateResponse,
        applicationQuestion: el,
      };
    });
    const candidateApplications = initialValues.candidateToApplications?.map(
      (el: ICandidateToApplication) => {
        const newCandidateApplication = {
          ...el,
          application: {
            id: formData.entities.application?.id,
            name: formData.entities.application?.name,
            applicationQuestions:
              formData.entities.application?.applicationQuestions || [],
          },
        };
        return newCandidateApplication;
      }
    );
    setInitialValues({
      ...initialValues,
      candidateQuestionResponses: candidateResponseQuestions,
      candidateToApplications: candidateApplications,
    });
  }, [props.formData]);

  useEffect(() => {
    executeScroll();
    formik.setErrors({});
    formik.setTouched({});
    formik.dirty = false;
  }, [stepper]);

  useEffect(() => {
    if (candidate && candidate?.id) {
      // is not NEW
      setIsNew(false);
      let address: IAddresFormik = initialDataAddress;
      if (candidate.address) {
        const addressCandidate = candidate.address;
        const addressProvince =
          candidate.address?.locality?.province || initialDataAddress.province;
        const addressCountry =
          candidate.address?.locality?.province?.country ||
          initialDataAddress.province;
        address = {
          ...addressCandidate,
          province: addressProvince,
          country: addressCountry,
        };
      }
      Object.keys(candidate).forEach(
        (e) => candidate[e] === null && delete candidate[e]
      );
      setInitialValues({
        ...initialValues,
        ...candidate,
        address,
      });
    } else {
      setIsNew(true);
    }
  }, [candidate]);

  useEffect(() => {
    if (validation.is_candidate && validation.is_postulate) {
      setShowModal(true);
      setShowAlreadyApplied(true);
    }
  }, [validation]);
  
  return (
    <div>
      {props.loadingCode && <SpinnerDni />}
      {formData.loading ? (
        <SpinnerKonecta />
      ) : (
        <div className="container-general-postulate">
          <Row>
            <Col className="text-center container-postulate-header">
              <div className="title-postulate">¡Postulate ahora!</div>
              <div className="subtitle-postulate">
                {formData.entities.application?.job?.name ? (
                  <>
                    {formData.entities.application.job.name
                      ?.charAt(0)
                      .toUpperCase()}
                    {formData.entities.application.job.name
                      ?.slice(1)
                      .toLowerCase()}
                  </>
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Row>

          <Row className="mt-5">
            <FormikProvider value={formik}>
              <Col md="2">
                <Stepper
                  stepper={stepper}
                  setStepper={setStepper}
                  formik={formik}
                  setErrorIncompleteFields={setErrorIncompleteFields}
                  setShowErrorsInputs={setShowErrorsInputs}
                  validate={validate}
                />
              </Col>
              <Col
                md="9"
                className="container-form-postulate"
                id="container-form-postulate"
              >
                <div ref={myRef}></div>

                <Form autoComplete="off" onSubmit={formik.handleSubmit}>
                  {stepper.current === 1 && (
                    <FirstStepForm
                      formik={formik}
                      setShowModal={setShowModal}
                      setShowDocExists={setShowDocExists}
                      setShowCode={setShowCode}
                      setShowSaved={setShowSaved}
                      showErrorsInputs={showErrorsInputs}
                    />
                  )}
                  {stepper.current === 2 && (
                    <SecondStepForm
                      formik={formik}
                      showErrorsInputs={showErrorsInputs}
                      setShowErrorsInputs={setShowErrorsInputs}
                    />
                  )}
                  {stepper.current === 3 && (
                    <ThirdStepForm
                      formik={formik}
                      showErrorsInputs={showErrorsInputs}
                      setShowErrorsInputs={setShowErrorsInputs}
                    />
                  )}
                  <ButtonsGroup
                    stepper={stepper}
                    setStepper={setStepper}
                    formik={formik}
                    getAdditionalQuestion={getAdditionalQuestion}
                    handleClose={handleClose}
                    setErrorIncompleteFields={setErrorIncompleteFields}
                    setShowErrorsInputs={setShowErrorsInputs}
                    validate={validate}
                  />
                </Form>
              </Col>
            </FormikProvider>
          </Row>

          {showModalQuestions && currentQuestion.numberOfQuestions > 0 && (
            <ModalQuestions
              setShowModalQuestions={setShowModalQuestions}
              showModalQuestions={showModalQuestions}
              currentQuestion={currentQuestion}
              getAdditionalQuestion={getAdditionalQuestion}
              formik={formik}
            />
          )}

          {showModal && (
            <ModalDocumentProcess
              setShowModal={setShowModal}
              showDocExists={showDocExists}
              setShowDocExists={setShowDocExists}
              showCode={showCode}
              setShowCode={setShowCode}
              showSaved={showSaved}
              setShowSaved={setShowSaved}
              showAlreadyApplied={showAlreadyApplied}
              setShowAlreadyApplied={setShowAlreadyApplied}
              handleClose={handleClose}
            />
          )}

          {showModalConfirm && (
            <ModalResponse
              loading={props.loadingRequest}
              errorMessage={props.errorMessageCandidate}
              updateSuccess={props.updateSuccess}
              messageSuccess={messageSuccess}
              handleClose={handleClose}
              setShowModalConfirm={setShowModalConfirm}
              saveConfirm={saveConfirm}
            />
          )}
          {props.errorMessageCandidate && (
            <ModalError
              error={props.errorMessageCandidate}
              handleClose={handleClose}
              errorCode={true}
            />
          )}
          {props.errorMessageCode && (
            <ModalError
              error={props.errorMessageCode}
              handleClose={handleClose}
            />
          )}
          {props.errorMessage && (
            <ModalError error={props.errorMessage} handleClose={handleClose} />
          )}
          {errorIncompleteFields && (
            <ModalError
              error={messageCompleteFields}
              handleClose={handleCloseIncompoleteFields}
            />
          )}
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state: IRootState) => {
  return {
    // postulate
    formData: state.postulateReducer,
    errorMessage: state.postulateReducer.errorMessage,
    // code
    validation: state.codeReducer.entity,
    errorMessageCode: state.codeReducer.errorMessage,
    loadingCode: state.codeReducer.loading,
    // candidate
    errorMessageCandidate: state.candidateReducer.errorMessage,
    updating: state.candidateReducer.updating,
    updateSuccess: state.candidateReducer.updateSuccess,
    loading: state.candidateReducer.loading,
    loadingRequest: state.candidateReducer.updating,
    candidate: state.candidateReducer.entity,
    // problem
    errorMessageProblem: state.problemReducer.errorMessage,
  };
};
const mapDispatchToProps = {
  getFormData,
  createCandidate,
  updateCandidate,
  resetCandidate,
  resetPostulate,
  resetCode,
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Postulate);
